import { BtnClsNames, homePgBtnStyles } from "./btn_config";
//..if more props needed pass them in
export const makeHomeBtns = ({ kb_id,chapter_id } = {}) => ([
  {
    id: 'people_to_call',
    location: '/contacts',
    text: 'People to Call',
    style: homePgBtnStyles.people_to_call,
    class: BtnClsNames,
    enabled:true
  },
  {
    id: 'resources',
    location: kb_id ? `/articles/${kb_id}` : '/articles/none',
    text: 'Important Resources',
    style: homePgBtnStyles.resources,
    class: BtnClsNames,
    enabled:kb_id ? true : false,
  },
  {
    id: 'ask_for_help',
    location: '/request',
    text: 'Ask for Help',
    style: homePgBtnStyles.request,
    class: BtnClsNames,
    enabled: chapter_id ? true : false,
  },
]);